// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c952ad02","453":"c8a534ee","455":"9dd8a677"}[chunkId] + ".chunk.js";
};